import { useCallback, useState } from 'react';
import type { TFunction } from 'i18next';

import { INVITE_OWNER_PROJECT_ID } from '../constants/inviteOwnerProjectId';
import { iAlert } from '../interfaces';
import { FamlaServices } from '../services';
import { useAppSelector } from '../stores';
import { isPrivateEmail } from '../utils/emailUtils';

export function useInviteOwnerModal(t: TFunction) {
    const accessToken = useAppSelector((state) => state.auth.access_token);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alert, setAlert] = useState<iAlert>({
        isActive: false,
        type: '',
        message: '',
    });

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.name === 'email') {
            setEmail(event.target.value);
        }
    }, []);

    const handleSubmit = useCallback(
        async (event: React.SyntheticEvent) => {
            event.preventDefault();
            if (!email.length) {
                setAlert({ isActive: true, type: 'danger', message: t('navigation.enterValideEmail') });
                return;
            }
            if (isPrivateEmail(email)) {
                setAlert({ isActive: true, type: 'warning', message: t('views.auth.professionalEmail') });
                return;
            }
            if (!accessToken) return;

            setIsSubmitting(true);
            try {
                const data = await FamlaServices(
                    'api_host',
                    '/project/add_owner/',
                    'PUT',
                    { project_id: INVITE_OWNER_PROJECT_ID, mail: [email] },
                    accessToken,
                );
                if (data.status === 200) {
                    setAlert({
                        isActive: true,
                        type: 'success',
                        message: t('navigation.invitationSentSuccessfully'),
                    });
                    setEmail('');
                    setTimeout(() => {
                        setAlert({ isActive: false, type: '', message: '' });
                    }, 3000);
                } else if (data.status === 404) {
                    setAlert({ isActive: true, type: 'danger', message: t('navigation.proJectNotFound') });
                } else if (data.status === 401) {
                    setAlert({ isActive: true, type: 'danger', message: t('navigation.youAreNotLoggedIn') });
                } else {
                    setAlert({ isActive: true, type: 'danger', message: t('navigation.anErrorOcured') });
                }
            } catch {
                setAlert({ isActive: true, type: 'danger', message: t('navigation.anErrorOcured') });
            } finally {
                setIsSubmitting(false);
            }
        },
        [accessToken, email, t],
    );

    return {
        email,
        isSubmitting,
        alert,
        handleChange,
        handleSubmit,
    };
}
